import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useFinstrongStore, useGlobalCopyStore } from '../../../common'
import ProgressBar from '../ProgressBar'
import { getDaysOfCashOnHandState } from '../../util/finstrongUtils'
import { buildDynamicCopy } from '../../../core/utils/Localization'

const SaveEnoughToLiveOnProgressBar = () => {
  const { finstrong: copy } = useGlobalCopyStore()

  const { healthScore } = useFinstrongStore()
  const noOfMonths = healthScore.months_of_cash_on_hand
  const cardStatus = getDaysOfCashOnHandState(noOfMonths ? noOfMonths * 30 : null) // Convert months to days for state calculation

  // Using 183 days as an approximate 6-month period
  const avgDaysPerMonth = 183 / 6
  const months = Math.floor(noOfMonths)
  const days = Math.round((noOfMonths - months) * avgDaysPerMonth)
  const percentage = (noOfMonths / 6) * 100
  const monthsToDisplay = ['0 Mo', '1 Mo', '2 Mo', '3 Mo', '4 Mo', '5 Mo', '6 Mo']

  return (
    <ProgressBar
      bottomComponent={
        <Stack
          sx={{
            flexDirection: 'row',
            height: 24,
            justifyContent: 'space-between',
            mt: 2,
            px: 1,
          }}
        >
          {monthsToDisplay.map((label) => (
            <Stack
              key={label}
              sx={{
                alignItems: 'center',
                height: 24,
              }}
            >
              <Divider
                orientation="vertical"
                sx={{
                  borderWidth: 1,
                  height: 8,
                }}
              />
              <Text variant="caption">{label}</Text>
            </Stack>
          ))}
        </Stack>
      }
      label={copy.key_indicators_save.drawer_progress_bar_label}
      status={cardStatus}
      statusBarData={[
        {
          percentage: `${percentage}%`,
        },
      ]}
      value={
        buildDynamicCopy(copy.key_indicators_save.drawer_progress_bar_value, months, days) as string
      }
    />
  )
}

export default observer(SaveEnoughToLiveOnProgressBar)
